module.exports = "<p>\n  You are now signed in.\n</p>\n"